import Vue from "vue";
import VueRouter from "vue-router";
import routes from "./routes";

Vue.use(VueRouter);

// configure router
const router = new VueRouter({
  routes, // short for routes: routes
  linkActiveClass: "active",
  scrollBehavior: (to, from, savedPosition) => {
    if (savedPosition) {
      return savedPosition;
    }
    if (to.hash) {
      return { selector: to.hash };
    }
    return { x: 0, y: 0 };
  },
});
router.beforeEach((to, from, next) => {
  const publicRoutes = ["/login", "/register"];
  const token = localStorage.getItem("tokenAbitue");

  if (!token && !publicRoutes.includes(to.path)) {
    // Sem token e a tentar aceder a rota protegida
    return next("/login");
  }

  // Permite continuar
  next();
});
export default router;
